import {requestUser, requestOrder, requestPayment} from '@/utils/request.js'

export function addBankCard(data) {
  return requestUser({
    url: `/user/addBankCard`,
    method: 'post',
    data
  });
}

export function creditCardSave(data) {
  return requestUser({
    url: `/creditCard/save`,
    method: 'post',
    data
  });
}

export function creditCardSelectOne(data) {
  return requestUser({
    url: `/creditCard/selectOne`,
    method: 'post',
    data
  });
}

export function creditCardDelete(data) {
  return requestUser({
    url: `/creditCard/delete`,
    method: 'post',
    data
  });
}

export function creditCardUpdate(data) {
  return requestUser({
    url: `/creditCard/update`,
    method: 'post',
    data
  });
}

export function creditCardList(data) {
  return requestUser({
    url: `/creditCard/list`,
    method: 'post',
    data
  });
}

//
export function creditCardListInPayment(data) {
  return requestUser({
    url: `/creditCard/listInPayment`,
    method: 'post',
    data
  });
}

export function paymentCardCreate(data) {
  return requestPayment({
    url: `/payment/card/create`,
    method: 'post',
    data
  });
}


/**
 * 支付结果查询
 * @param orderType 交易类型,可用值:TRADE,ORDER,RECHARGE
 * @param sn   订单编号
 */
export function withdrawalSettingVO(params) {
  return requestUser({
    url: `/buyer/wallet/wallet/withdrawalSettingVO`,
    needToken: true,
    method: Method.GET,
    params
  });
}

// 发起支付：支付宝
export function goAlipay(data) {
  return requestPayment({
    url: `/alipay/pay`,
    method: 'post',
    data
  });
}

// MyMoney发起支付
export function goPay(data) {
  return requestPayment({
    url: `/payment/create`,
    method: 'post',
    data
  });
}

export function paymentGetOne(data) {
  return requestPayment({
    url: `/payment/getOne`,
    method: 'post',
    data
  });
}

// 流水分页
export function balanceFlowPage(data) {
  return requestPayment({
    url: `/balanceFlow/page`,
    method: 'post',
    data
  });
}

// 获取当前余额
export function walletGetBalance(data) {
  return requestPayment({
    url: `/wallet/getBalance`,
    method: 'post',
    data
  });
}

// 获取可用余额
export function getAvailableBalance(data) {
  return requestPayment({
    url: `/wallet/wallet/getAvailableBalance`,
    method: 'post',
    data
  });
}

// 获取冻结金额
export function getFreezeBalance(data) {
  return requestPayment({
    url: `/wallet/wallet/getFreezeBalance`,
    method: 'post',
    data
  });
}

// 提现
export function balanceApplicationRecordWithdraw(data) {
  return requestPayment({
    url: `/balanceApplicationRecord/withdraw`,
    method: 'post',
    data
  });
}

// 余额支付
export function paymentBalance(data) {
  return requestPayment({
    url: `/payment/balance/create`,
    method: 'post',
    data
  });
}

// 支付 预估欠款平账
export function debtSettlement(data) {
  return requestOrder({
    url: `/order/shelf/debtSettlement`,
    method: 'post',
    data
  });
}


// 查询支付状态
export function getPayStatus(data) {
  return requestPayment({
    url: `/payment/getOne`,
    method: 'post',
    data
  });
}

// 查询微信支付状态
export function getMobilePaymentStatus(data) {
  return requestPayment({
    url: `/payment/getMobilePaymentStatus`,
    method: 'post',
    data
  });
}

// 订单支付有效期
export function findSetting(data) {
  return requestOrder({
    url: `/orderSetting/findSetting`,
    method: 'post',
    data
  });
}


// 获取当前登录用户的信用卡数量
export function getCreditCardCount() {
  return requestUser({
    url: `/creditCard/count`,
    method: 'post'
  });
}


// 根据验证码设置支付密码
export function setPasswordByCode(data) {
  return requestPayment({
    url: `/wallet/setPasswordByCode`,
    method: 'post',
    data
  });
}

//根据原密码修改支付密码
export function setPasswordByOldPassword(data) {
  return requestPayment({
    url: `/wallet/setPasswordByOldPassword`,
    method: 'post',
    data
  });
}

// 校验银行卡号是否有效
export function isBankCardNoValid(data) {
  return requestPayment({
    url: `/balanceApplicationRecord/isBankCardNoValid`,
    method: 'post',
    data
  });
}


// 当前货架需要平账的金额
export function getMinPayAmount(data) {
  return requestOrder({
    url: `/order/shelf/getMinPayAmount`,
    method: 'post',
    data
  });
}


// 获取支付手续费
export function getPaymentData(data) {
  return requestUser({
    url: `/userHandlingFee/getPaymentData`,
    method: 'post',
    data
  });
}




// WEBPACK FOOTER //
// ./src/api/card.js